import React from 'react';
import { Heart, Send, Loader2 } from 'lucide-react';

interface PropertyActionsProps {
  userHasLiked: boolean;
  canSendInquiry: boolean;
  actionLoading: string | null;
  onLike: () => void;
  onInitiateInquiry: () => void;
}

export const PropertyActions: React.FC<PropertyActionsProps> = ({
  userHasLiked,
  canSendInquiry,
  actionLoading,
  onLike,
  onInitiateInquiry,
}) => {
  return (
    <div className="flex gap-2">
      <button
        onClick={onLike}
        disabled={actionLoading === 'like' || userHasLiked}
        className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-semibold transition-all ${
          userHasLiked
            ? 'bg-pink-100 text-pink-600 border-2 border-pink-300'
            : 'bg-white border-2 border-gray-200 text-text-primary hover:border-primary-200 active:scale-95'
        }`}
      >
        {actionLoading === 'like' ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Heart className={`w-4 h-4 ${userHasLiked ? 'fill-current' : ''}`} />
        )}
        {userHasLiked ? 'Liked' : 'Like'}
      </button>

      {canSendInquiry && (
        <button
          onClick={onInitiateInquiry}
          className="flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-semibold bg-gradient-to-r from-primary-200 to-primary-300 text-white hover:from-primary-300 hover:to-primary-400 transition-all active:scale-95"
        >
          <Send className="w-4 h-4" />
          Send Inquiry
        </button>
      )}
    </div>
  );
};
